import { render, staticRenderFns } from "./patient-address-multi-client-unit.vue?vue&type=template&id=6a3a7d80&scoped=true&lang=pug&"
import script from "./patient-address-multi-client-unit.vue?vue&type=script&lang=ts&"
export * from "./patient-address-multi-client-unit.vue?vue&type=script&lang=ts&"
import style0 from "./patient-address-multi-client-unit.vue?vue&type=style&index=0&id=6a3a7d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3a7d80",
  null
  
)

export default component.exports